<template>
  <v-container style="background-color: #F0F0EF; height: 535px; overflow: auto">
    <v-row>
      <v-col>
        <span
          >{{ $tc("TheWorkOrder") }}
          <span class="font-weight-bold">{{ receivedData.label }}</span>
          {{ $tc("WithPriority") }}
          <span class="font-weight-bold">{{
            receivedData.priority.label
          }}</span>
          {{ $tc("ShouldStart") }}
          <span class="font-weight-bold">{{ receivedData.start_date }}</span>
          {{ $tc("AndIsExpected") }} {{ $tc("ToEndBy") }}
          <span class="font-weight-bold"
            >{{ receivedData.end_date }}.</span
          ></span
        >
        <div v-on-clickaway="reset" v-if="actionType === 'edit'">
          <div class="text-start ">
            <div class="d-flex mt-3 mb-3 align-center" style="width: 100%">
              <span style="width: 50px">Activities:</span>
              <ActivityTasksState
                :activitiesOrTasks="receivedData.activities"
                @isActive="setState"
                :class="{ opacity: objectType === null && state !== null }"
              />
            </div>
          </div>
          <div class="text-start ">
            <div class="d-flex mt-3 mb-3 align-center" style="width: 100%">
              <span style="width: 50px">Tasks:</span>
              <ActivityTasksState
                :activitiesOrTasks="taskSelection"
                @isActive="setState"
                :class="{ opacity: objectType !== null && state !== null }"
              />
            </div>
          </div>
        </div>

        <v-sheet
          class="d-flex justify-start align-end pl-1 mb-1"
          color="#F0F0EF"
          height="30"
        >
          <span> {{ $tc("WorkOrder") }} &#8226; </span>

          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" class="text-size ml-2">{{
                title
              }}</span>
            </template>
            <v-date-picker
              v-model="date"
              @input="menu2 = false"
            ></v-date-picker>
          </v-menu>
        </v-sheet>
        <calendar
          ref="calendar"
          :receivedEvents="showDetails"
          :choosenDate="date"
          :startDate="receivedData.start_date"
          :endDate="receivedData.end_date"
          height="300"
          :disabledView="disabledView"
          :disabled="true"
        />
        <v-spacer></v-spacer>
        <table style="width: 100%;" class="mt-2" cellspacing="0">
          <thead>
            <tr class="text-left">
              <th
                v-for="header of headers"
                :key="header.name"
                style="text-align: left;"
              >
                {{ header.name }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(activities, activitiesIndex) of receivedData.activities"
              :key="activitiesIndex"
              class="align-top"
              :class="{
                opacity: state !== activities.state,
                'task-opacity':
                  (state !== activities.state &&
                    activities.tasks.find(item => item.state === state)) ||
                  state === null
              }"
            >
              <td
                v-if="!selectedTemplates.includes(activities.title)"
                style="max-width: 100px"
                class="text-truncate"
              >
                <span class="font " :title="activities.title">{{
                  activities.title
                }}</span>
              </td>
              <td class="table-border text-truncate" style="max-width: 150px">
                <span
                  class="font "
                  v-if="activities.label"
                  :title="activities.label"
                >
                  {{ activities.label }}</span
                >
                <span
                  class="font text-truncate"
                  v-else
                  :title="
                    getObjectTypeLabel(activities.object_type) +
                      ' ' +
                      activities.id
                  "
                >
                  {{ getObjectTypeLabel(activities.object_type) }}
                  {{ activities.id }}</span
                >
              </td>
              <td>
                <ul class="table-border">
                  <li
                    v-for="(tasks, i) of activities.tasks"
                    :key="i"
                    class="align-center  "
                    style="max-width: 100px"
                    :class="{
                      opacity: tasks.state !== state,
                      'task-opacity':
                        state === activities.state || state === null
                    }"
                  >
                    <div
                      :class="{ 'd-flex': tasks.state, 'mt-1': tasks.state }"
                      class="text-truncate"
                    >
                      <task-state-icon :state="tasks.state" />
                      <span class="font " :title="tasks.title">{{
                        tasks.title
                      }}</span>
                    </div>
                  </li>
                </ul>
              </td>
              <td>
                <ul class="table-border">
                  <li
                    v-for="(tasks, i) of activities.tasks"
                    :key="i"
                    style="width: 100%"
                    :class="{
                      opacity: tasks.state !== state,
                      'task-opacity':
                        state === activities.state || state === null
                    }"
                  >
                    <div
                      class="d-flex  align-center "
                      v-if="tasks.user_assignee_id"
                    >
                      <div>
                        <v-tooltip bottom color="white" content-class="toolTip">
                          <template v-slot:activator="{ on, attrs }">
                            <v-avatar
                              height="17"
                              width="17"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <img :src="getImageUrl(tasks.user_assignee_id)" />
                            </v-avatar>
                          </template>
                          <span class="toolTip">{{
                            getUserName(tasks.user_assignee_id)
                          }}</span>
                        </v-tooltip>
                      </div>
                    </div>
                    <div class="d-flex  align-center " v-else>
                      <div>
                        <v-tooltip bottom color="white" content-class="toolTip">
                          <template v-slot:activator="{ on, attrs }">
                            <v-avatar
                              height="17"
                              width="17"
                              v-bind="attrs"
                              v-on="on"
                              left
                            >
                              <img :src="getCompanyImage(tasks.company_id)" />
                            </v-avatar>
                          </template>
                          <span v-if="tasks.company_id" class="toolTip">{{
                            getCompanyName(tasks.company_id)
                          }}</span>
                          <span class="toolTip" v-else
                            >No Company or User selected</span
                          >
                        </v-tooltip>
                      </div>
                    </div>
                  </li>
                </ul>
              </td>
              <td>
                <ul class="table-border">
                  <li
                    v-for="(tasks, i) of activities.tasks"
                    :key="i"
                    :class="{
                      opacity: tasks.state !== state,
                      'task-opacity':
                        state === activities.state || state === null
                    }"
                  >
                    {{
                      tasks.scheduled_date
                        ? getDateTime(tasks.scheduled_date)
                        : "No Date"
                    }}
                  </li>
                </ul>
              </td>
              <td>
                <ul class="table-border">
                  <li
                    v-for="(tasks, i) of activities.tasks"
                    :key="i"
                    style="color: #B8B8BC"
                  >
                    {{ tasks.execution_time }} Min
                  </li>
                </ul>
              </td>
            </tr>

            <tr></tr>
            <tr></tr>
          </tbody>
        </table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import calendar from "./WorkOrderCalendar.vue";
import { activitiesTasksDataMixin } from "../../../../mixins/field/activitiesTasksDataMixin";
import ActivityTasksState from "./_Organisms/ActivityTasksState.vue";
import TaskStateIcon from "./_Atoms/TaskStateIcon.vue";
import { mixin as clickaway } from "vue-clickaway";

export default {
  name: "WorkOrderSummary",

  components: { calendar, ActivityTasksState, TaskStateIcon },
  mixins: [activitiesTasksDataMixin, clickaway],
  data() {
    return {
      events: [],
      menu2: false,
      date: null,
      title: null,
      state: null,
      objectType: null
    };
  },

  props: {
    receivedData: {
      type: Object
    },
    disabledView: {
      type: Boolean
    },
    actionType: {
      type: String
    }
  },
  mounted() {
    this.fetchUserCompanies();
    this.$nextTick(() => {
      this.title = this.$refs.calendar.weekTitle;
    });
  },

  updated() {
    this.title = this.$refs.calendar.weekTitle;
  },
  computed: {
    /**
     * @returns -  every task
     */
    showDetails() {
      let arr = [];

      this.receivedData.activities.forEach(element => {
        element.tasks.filter(element => {
          if (
            element.state === this.state ||
            element.stateSelector === this.state
          )
            arr.push(element);
          if (this.state === null) {
            arr.push(element);
          }
        });
      });
      return arr;
    },
    /**
     * @returns -  every task
     */
    taskSelection() {
      let arr = [];
      this.receivedData.activities.forEach(activity => {
        activity.tasks.forEach(element => {
          element.stateSelector = activity.state;
          arr.push(element);
        });
      });
      return arr;
    },

    /**
     * returns unique selected templates
     */
    selectedTemplates() {
      return this.$store.state.workOrders.selectedTemplates;
    },
    headers() {
      return [
        {
          name: "Activities"
        },
        {
          name: "Assets"
        },
        {
          name: "Tasks"
        },
        {
          name: "Assignment"
        },
        {
          name: "Date"
        },
        {
          name: "Duration"
        }
      ];
    }
  },
  methods: {
    /**
     * @returns - Number of tasks that have the same name
     */
    numberOfTaskStates(tasks) {
      return `${tasks.state} (${
        tasks.filter(item => item.state === state).length
      })} `;
    },
    /**
     * resets the filter if you click away
     */
    reset() {
      this.state = null;
      this.objectType = null;
    },
    setState(state, object) {
      (this.state = state), (this.objectType = object ? object : null);
    }
  }
};
</script>
<style scoped>
th {
  border-bottom: 1px solid #aaaaaa;
  padding: 0.5rem 0.5rem 0.5rem 0;
}
td {
  vertical-align: center;
}
.font {
  font-family: roboto;
  font-size: 13px;
  letter-spacing: 0.1px;
  color: #666666;
  opacity: 1;
}

.table-border {
  padding: 0px 0px 5px 0px;
  border-bottom: 1px solid #aaaaaa;
  list-style: none;
  text-align: left;
  vertical-align: top;

  font: normal normal normal 12px/24px Roboto;
  letter-spacing: 0.1px;
  color: #666666;
  opacity: 1;
}
.toolTip {
  text-align: left;
  font: normal normal normal 10px/13px Roboto;
  letter-spacing: 0px;
  color: #666666;
  opacity: 1;
}
.align-top {
  text-align: left;
  vertical-align: top;
}
span {
  text-align: left;
  font: normal normal normal 14px/18px Roboto;
  letter-spacing: 0.11px;
  color: #666666;
}
.opacity {
  opacity: 0.4;
}
.task-opacity {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/WorkOrderForm/WorkOrderSummary.vue